// extracted by mini-css-extract-plugin
export default {"preloaderContainer":"Preloader_preloaderContainer__DAPYd","loader":"Preloader_loader__gLG+H","loaderGIF":"Preloader_loaderGIF__RtxqA"};